/* eslint-disable react/no-danger */
import classNames from 'classnames';
import isSameDay from 'date-fns/isSameDay';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useParseDates } from '../../hooks/useDates';

import DatePartial from './Date';
import TimePartial from './Time';

import styles from '../../../styles/partials/date-line.module.scss';

const propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    capitalize: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    startDate: null,
    endDate: null,
    capitalize: false,
    className: null,
};

const DateLine = ({
    startDate: initialStartDate,
    endDate: initialEndDate,
    capitalize,
    className,
}) => {
    const { startDate, endDate } = useParseDates(initialStartDate, initialEndDate);
    const hasEnd = endDate !== null;
    const endIsSameDay =
        startDate !== null && endDate !== null ? isSameDay(startDate, endDate) : false;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {startDate !== null ? (
                <DatePartial date={startDate} className={styles.date} capitalize={capitalize} />
            ) : null}
            {hasEnd && endIsSameDay ? (
                <span className={styles.dark}>
                    <span className={styles.to}>&nbsp;—&nbsp;</span>
                    <TimePartial dateTime={endDate} />
                </span>
            ) : null}
            {hasEnd && !endIsSameDay ? (
                <span className={styles.dark}>
                    <span className={styles.to}>
                        &nbsp;
                        <FormattedMessage defaultMessage="to" desctription="Label" />
                        &nbsp;
                    </span>
                    <DatePartial date={endDate} className={styles.date} capitalize={capitalize} />
                </span>
            ) : null}
        </div>
    );
};

DateLine.propTypes = propTypes;
DateLine.defaultProps = defaultProps;

export default DateLine;
